import BaseSimulatorController from './base_simulator_controller'
import { formatCurrency } from '../utils/currency'

export default class RoyaltiesSimulatorController extends BaseSimulatorController {
  static values = {
    profitability: Number,
    capitalGain: Number,
    maturity: Number
  }

  static targets = [
    'input',
    'investedAmount',
    'estimatedReturn',
    'estimatedAnnualProfitability',
    'estimatedTotalCapitalGain',
    'finalCapital'
  ]

  refresh(value) {
    if (!value || !this.profitabilityValue || !this.maturityValue) return

    const estimatedAnnualProfitability = value * this.profitabilityValue
    const estimatedTotalCapitalGain = value * this.capitalGainValue
    const finalCapital = (value * this.profitabilityValue * this.maturityValue) +
      (value * this.capitalGainValue) +
      value
    const estimatedReturn = finalCapital - value

    this.investedAmountTarget.textContent = formatCurrency(value)
    this.estimatedAnnualProfitabilityTarget.textContent = formatCurrency(estimatedAnnualProfitability)
    this.estimatedTotalCapitalGainTarget.textContent = formatCurrency(estimatedTotalCapitalGain)
    this.estimatedReturnTarget.textContent = formatCurrency(estimatedReturn, { signed: true })
    this.finalCapitalTarget.textContent = formatCurrency(finalCapital)
  }
}
